import React, { Component } from 'react';
import { connect } from 'react-redux';

import RsvpService from '../../services/RsvpService';
import {__, STR_KEY} from '../../services/Translate';

import { 
    EventsTable,
    Footer,
    Header,
} from '../../components';

import {
    updateAccount,
    updateContact,
    //updateEvent,
    //updateEventAttendance,
    //updateSessionAttendances
} from '../../redux/actions';

export class IdPage extends Component {

    rsvpService = new RsvpService();

    state = {
        eventsActive: [],
        eventsPast: []
    };

    UNSAFE_componentWillMount() {

        let data = this.rsvpService.parseEvents(this.props);

        // Update redux store
        this.props.updateStore(data);

        // Update events list
        this.setState({
            eventsActive: data.eventsActive.toArray(), 
            eventsPast: data.eventsPast.toArray()
        });

        //Set page title
        document.title = `${data.contact.full_name} - My Events List Page | Gecko`;  
    }

    renderEventsActive() {
        return <EventsTable name={__(STR_KEY.EVENTS_PAGE_TITLE_ACTIVE)} rows={this.state.eventsActive} contact={this.props.contact} account={this.props.account} />
    }

    renderEventsPast() {
        return <EventsTable name={__(STR_KEY.EVENTS_PAGE_TITLE_PAST)} rows={this.state.eventsPast} />
    }

    render() {
        return (
            <>
                <Header name={this.props.contact.full_name} />
                <main>
                    <div className="public-form-holder"> 
                        {this.renderEventsActive()}
                        {this.renderEventsPast()}
                    </div>  
                </main>  
                <Footer />
            </>
        );
    }
}

const mapStateToProps = store => {
    return {
        // account: store.account,
        // contact: store.contact,
        // eventAttendance: store.eventAttendance,
        // sessionAttendances: store.sessionAttendances
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateStore: (data) => {
            dispatch(updateAccount(data.account));
            dispatch(updateContact(data.contact));
            //dispatch(updateEvent(data.event));
            //dispatch(updateEventAttendance(data.eventAttendance));
            //dispatch(updateSessionAttendances(data.sessionAttendances));
        }
    }
}

export default connect(
    mapStateToProps, 
    mapDispatchToProps,
)(IdPage);